import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type PulsesFoundPeriodValue = 'today' | 'yesterday' | 'last_7_days' | 'last_30_days' | 'all';

interface PulsesFoundPeriodStore {
  period: PulsesFoundPeriodValue;
  setPeriod: (period: PulsesFoundPeriodValue | string) => void;
}

export const usePulsesFoundPeriodStore = create<PulsesFoundPeriodStore>()(
  persist(
    (set) => ({
      period: 'all',
      setPeriod: (period) => set({ period: period as PulsesFoundPeriodValue }),
    }),
    {
      name: 'pulses-found-period-storage',
      partialize: (state) => ({ period: state.period }),
    }
  )
);
